import { Link } from "react-router-dom";

export default function CasesHero() {
  return (
    <section className="relative flex min-h-[420px] md:min-h-[500px] items-end justify-center overflow-hidden bg-primary-950">
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950 via-primary-900 to-primary-950"></div>
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-16 left-10 w-72 h-72 rounded-full bg-accent-500 blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-80 h-80 rounded-full bg-accent-500 blur-3xl"></div>
      </div>

      <div className="relative z-10 w-full mx-auto max-w-6xl px-4 md:px-6 py-20 md:py-24">
        <nav className="flex items-center gap-2 text-xs text-white/60">
          <Link to="/" className="hover:text-white transition-colors">홈</Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-white">성공사례</span>
        </nav>
        <p className="mt-6 inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-xs font-medium text-accent-300 tracking-wide">
          <i className="ri-trophy-line"></i>
          WINNING CASES
        </p>
        <h1 className="mt-5 font-heading text-3xl md:text-5xl font-bold text-white leading-tight">
          재판의 흐름을 아는 변호사의<br />
          <span className="text-accent-400">성공사례</span>
        </h1>
        <p className="mt-5 max-w-2xl text-sm md:text-lg text-white/80 leading-relaxed">
          광주판사·검사출신변호사로서 쌓아온 신뢰의 결과물입니다.
          <br className="hidden md:block" />
          각 사례는 의뢰인 정보 보호를 위해 요약된 내용입니다.
        </p>
      </div>
    </section>
  );
}